import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewComponent } from "../warp-preview/preview/preview.component";
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { filter, map } from 'rxjs';
import { AnswersStore } from 'src/app/store/answers-store';
import { ActivatedRoute } from '@angular/router';
import { DragStore } from 'src/app/store/drag-store';
import { ApprovalStore } from '../approvals/store/approval-store';

@Component({
    selector: 'que-view-answers',
    imports: [CommonModule, PreviewComponent],
    providers: [QuestionnaireStore, AnswersStore, DragStore, ApprovalStore],
    templateUrl: './view-answers.component.html',
    styleUrls: ['./view-answers.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewAnswersComponent {
  #questionnaireStore = inject(QuestionnaireStore);
  #answersStore = inject(AnswersStore);
  #activeRoutes = inject(ActivatedRoute);


  questionnaireName = this.#questionnaireStore.name$;
  ngOnInit(): void {

    const guid$ = this.#activeRoutes.params.pipe(
      map(p => p['guid']), filter(x => x != 0))

    const status$ = this.#activeRoutes.params.pipe(
      map(p => p['status'])
    );

    this.#questionnaireStore.fetchQuestionnaireByGuid(guid$)
    this.#answersStore.updateQuestionnaireGuid(guid$)
    this.#answersStore.updateApprovalMode(status$)
  }

}
